module.exports = __webpack_public_path__ + "img/batch-mode-example.a2540d5f.gif";